exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Lightbox__root___1obzm {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  position: fixed;\n  top: 0;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 20;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.Lightbox__backdrop___2jjCw {\n  position: absolute;\n  background: rgba(34, 34, 34, .85);\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: -1;\n}\n\n.Lightbox__image___3hAFt {\n  max-width: 100vw;\n  max-height: 100vh;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n", ""]);

// exports
exports.locals = {
	"root": "Lightbox__root___1obzm",
	"backdrop": "Lightbox__backdrop___2jjCw",
	"image": "Lightbox__image___3hAFt"
};